/**
 * filter
 *
 * @author Shigq
 * @date 2021/11/9 15:29
 */
import { filter } from '@libs/utils'

export default app => {
  app.config.globalProperties.$filters = {
    currency: filter.currency,
    date: filter.date
  }
}
